import { render, staticRenderFns } from "./cityexam.vue?vue&type=template&id=52872bbe&scoped=true&"
import script from "./cityexam.vue?vue&type=script&lang=js&"
export * from "./cityexam.vue?vue&type=script&lang=js&"
import style0 from "./cityexam.vue?vue&type=style&index=0&lang=less&"
import style1 from "./cityexam.vue?vue&type=style&index=1&id=52872bbe&lang=less&scoped=true&"
import style2 from "./cityexam.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52872bbe",
  null
  
)

export default component.exports